var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index_header" }, [
    _vm._m(0),
    _c("div", { staticClass: "ih_right clearfix" }, [
      _c("div", { staticClass: "search clearfix" }, [
        _c("div", { staticClass: "search_content" }, [
          _c("img", {
            staticClass: "search_img",
            attrs: { src: require("@/assets/search.png") },
          }),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchContent,
                expression: "searchContent",
              },
            ],
            staticClass: "input_content",
            attrs: { type: "text", placeholder: _vm.holderText },
            domProps: { value: _vm.searchContent },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.search()
              },
              blur: function ($event) {
                return _vm.changeState()
              },
              focus: function ($event) {
                return _vm.getLinkList()
              },
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchContent = $event.target.value
                },
                function ($event) {
                  return _vm.getLinkList()
                },
              ],
            },
          }),
          _c("div", { staticClass: "history_content" }, [
            _vm.showHistory || _vm.showHistoryDialog
              ? _c(
                  "ul",
                  {
                    on: {
                      mouseenter: function ($event) {
                        _vm.showHistoryDialog = true
                      },
                      mouseleave: function ($event) {
                        _vm.showHistoryDialog = false
                      },
                    },
                  },
                  [
                    _c("li", { staticClass: "history_bar" }, [
                      _vm._v(" 搜索历史 "),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.removeHistory()
                            },
                          },
                        },
                        [_vm._v("清空")]
                      ),
                    ]),
                    _vm._l(_vm.searchHistory, function (item) {
                      return _c(
                        "li",
                        { key: item, staticClass: "history_item" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "history_text",
                              on: {
                                click: function ($event) {
                                  return _vm.search(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item))]
                          ),
                          _c("div", {
                            staticClass: "el-icon-error",
                            on: {
                              click: function ($event) {
                                return _vm.removeHistory(item)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm.showLink || _vm.showLinkDialog
              ? _c(
                  "ul",
                  {
                    on: {
                      mouseenter: function ($event) {
                        _vm.showLinkDialog = true
                      },
                      mouseleave: function ($event) {
                        _vm.showLinkDialog = false
                      },
                    },
                  },
                  _vm._l(_vm.linkList, function (item) {
                    return _c(
                      "li",
                      {
                        key: item.suggest_text,
                        staticClass: "suggestion_item",
                      },
                      [
                        _c("div", {
                          staticClass: "suggestion_text",
                          domProps: { innerHTML: _vm._s(item.suggest_text) },
                          on: {
                            click: function ($event) {
                              return _vm.search(item.suggest_text)
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]),
        _c(
          "button",
          {
            staticClass: "search_button",
            on: {
              click: function ($event) {
                return _vm.search()
              },
            },
          },
          [_vm._v("搜索")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "outer_link" },
        [
          _c(
            "el-link",
            {
              attrs: { underline: false, href: "/download", target: "_blank" },
            },
            [_vm._v("下载APP")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ih_left" }, [
      _c("a", { attrs: { href: "/" } }, [
        _c("img", { attrs: { src: require("@/assets/logo.png"), alt: "" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }